import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import { IEditCostCenterCostUnitDistribution } from '../../../../models/edit-cost-center-cost-unit-distribution.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { IJoinCostCenterCostUnitState } from '../../../../services/facades/master-data/join-cost-center-cost-unit-state.model';
import { JoinCostCenterCostUnitFacade } from '../../../../services/facades/master-data/join-cost-center-cost-unit.facade';

@Component({
    selector: 'app-cost-type-dialog',
    templateUrl: './join-cost-center-cost-unit-dialog.component.html',
    styleUrls: [ './join-cost-center-cost-unit-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JoinCostCenterCostUnitDialogComponent implements OnInit, AfterViewInit {
    public joinCostCenterCostUnitState$: Observable<IJoinCostCenterCostUnitState>;
    public formGroup: FormGroup;
    public dialogFieldsValid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(
        private myMatDialogRef: MatDialogRef<JoinCostCenterCostUnitDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IEditCostCenterCostUnitDistribution,
        private joinCostCenterCostUnitFacade: JoinCostCenterCostUnitFacade,
    ) {
    }

    public ngOnInit(): void {
        this.joinCostCenterCostUnitState$ = this.joinCostCenterCostUnitFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((distribution: IEditCostCenterCostUnitDistribution) => {
            this.validateDialogFields(distribution);
        });
    }

    public async save(): Promise<void> {
        const data = this.formGroup.value as IEditCostCenterCostUnitDistribution;
        if (!isNullOrUndefined(this.data.id)) {
            await this.joinCostCenterCostUnitFacade.updateDistributionValidity(this.data.id, data.validTo);
        } else {
            await this.joinCostCenterCostUnitFacade.addAssignment(data);
        }
        this.myMatDialogRef.close(true);
    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    public validateDialogFields(distribution: IEditCostCenterCostUnitDistribution): void {
        // Validations to disable saving/editing
        if (!distribution.costUnitId
            || !distribution.costAccountingTypeId
            || !distribution.validFrom) {
            this.dialogFieldsValid.next(false);
        } else {
            this.dialogFieldsValid.next(true);
        }
    }

}
